import useTranslation from 'next-translate/useTranslation';
import { Pagination } from 'antd';
import { Tooltip } from '@arkestro/arkestro-design-system';
import { ScreenReaderOnlyText } from '@shared/ScreenReaderOnlyText';
import { PAGE_SIZE_OPTIONS } from '@utils/line-items';
import type { LotPageOptions } from '@features/buyer-line-items-pagination/types/lot-page-options';
import type { ID } from 'types';

interface LotPagePaginatorProps {
  lotId: ID;
  pageOptions: LotPageOptions;
}

export const LotPagePaginator = ({ lotId, pageOptions }: LotPagePaginatorProps) => {
  const { t } = useTranslation('common');
  const lockedMessage = t('bid_request.line_items.pagination.locked');

  return (
    <Tooltip title={pageOptions.isPagingLocked ? lockedMessage : undefined}>
      <div data-testid={`lot-${lotId}-pagination-wrapper`}>
        <span role='status'>
          {pageOptions.isPagingLocked && <ScreenReaderOnlyText>{lockedMessage}</ScreenReaderOnlyText>}
        </span>
        <Pagination
          align='end'
          current={pageOptions.currentPage}
          data-testid={`lot-${lotId}-pagination`}
          disabled={pageOptions.isPagingLocked}
          onChange={pageOptions.onPageChange}
          pageSize={pageOptions.pageSize}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
          total={pageOptions.total}
        />
      </div>
    </Tooltip>
  );
};
